import API from './base';

export const getAdminConfiguration = () => API.managmentGet(`admin/configuration`, {});

export const updateAdminConfiguration = data => API.managmentPatch(`admin/configuration`, data);
